export const createURL = (
  param: string,
  value: string | number,
  {
    searchTerm,
    selectedCategory,
    sort,
    currentPage,
  }: {
    searchTerm: string
    selectedCategory: string
    sort: string
    currentPage: number
  },
) => {
  const url = new URLSearchParams()
  if (searchTerm) url.set('search', searchTerm)
  if (sort !== '-fields.publishedAt') url.set('sort', sort)
  if (currentPage > 1) url.set('page', currentPage.toString())

  if (param === 'categories') {
    if (value !== '') url.set('categories', value as string)
  } else {
    url.set(param, value.toString())
  }

  return `?${url.toString()}`
}
